"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3646],{

/***/ 3646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GarageProfileAbout": function() { return /* binding */ GarageProfileAbout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


var GarageProfileAbout = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(function(param) {
    var garage = param.garage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: garage.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "garageProfile:_about col-span-full mb-10",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                    className: "text-3xl font-serif mb-8",
                    children: [
                        "\xdcber ",
                        garage.name
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-5 profileText overflow-hidden",
                    dangerouslySetInnerHTML: {
                        __html: garage.description.replace(/(<div|(<\/?p)|(<\/?strong)|(<\/?h)([0-6])|<b(?!r))[^>]*>?/gm, "")
                    }
                })
            ]
        })
    });
});
GarageProfileAbout.displayName = "GarageProfileAbout";


/***/ })

}]);